'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.isInlineBanned = isInlineBanned;
exports.moveToEndOf = moveToEndOf;
exports.moveToStartOf = moveToStartOf;
exports.resolvePointAtStartOfNode = resolvePointAtStartOfNode;
exports.resolvePointAtEndOfNode = resolvePointAtEndOfNode;

var _slate = require('slate');

var _constants = require('./constants');

/**
 * Return true if settings bans the inline type, or it is void.
 *
 * @param {Editor} editor
 * @param {Inline} inline
 * @param {Object} opts
 * @return {Boolean}
 */

function isInlineBanned(editor, inline, opts) {
  var allowedTypes = opts.allowedTypes,
      bannedTypes = opts.bannedTypes;

  // Something crazy happened, there is no inline, or somehow focus inline is not an inline.

  if (!inline || inline.object !== 'inline' || editor.isVoid(inline)) return true;

  // The inline we are working with isn't allowed by user config.
  if (allowedTypes && !allowedTypes.includes(inline.type)) return true;
  if (bannedTypes.includes(inline.type)) return true;

  return false;
}

/**
 * Prevents default event behavior, and either collapses to or extends to the start
 * of a node
 *
 * @param {Editor} editor
 * @param {Node} node
 * @param {Event} event
 * @param {Number} offset (optional)
 * @return {Editor}
 */

function moveToEndOf(editor, node, event, state) {
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  event.preventDefault();
  state.sticky = offset === 0 ? _constants.STICKY_LEFT : null;
  return event.shiftKey ? editor.moveFocusToEndOfNode(node).moveFocusForward(offset) : editor.moveToEndOfNode(node).moveForward(offset);
}

/**
 * Prevents default event behavior, and either collapses to or extends to the end
 * of a node
 *
 * @param {Editor} editor
 * @param {Node} node
 * @param {Event} event
 * @param {Number} offset (optional)
 * @return {Editor}
 */

function moveToStartOf(editor, node, event, state) {
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  event.preventDefault();
  state.sticky = offset === 0 ? _constants.STICKY_RIGHT : null;
  return event.shiftKey ? editor.moveFocusToStartOfNode(node).moveFocusForward(offset) : editor.moveToStartOfNode(node);
}

/**
 * Returns the point at the very end of the previous text under the
 * same block.
 *
 * @param {Point} point
 * @param {Node} node
 * @return {Point}
 */

function pointAtEndOfPreviousText(point, node) {
  var block = node.getClosestBlock(point.path);
  var depth = node.getDepth(block.key);
  var relativePath = _slate.PathUtils.drop(point.path, depth);

  var _block$texts = block.texts({ path: relativePath, direction: 'backward' }),
      _block$texts2 = _slicedToArray(_block$texts, 1),
      previous = _block$texts2[0];

  if (previous) {
    var _previous = _slicedToArray(previous, 2),
        previousText = _previous[0],
        previousPath = _previous[1];

    var absolutePath = point.path.slice(0, depth).concat(previousPath);

    return point.merge({
      key: previousText.key,
      path: absolutePath,
      offset: previousText.text.length
    });
  } else {
    return point;
  }
}

/**
 * Assuming point is at the start of node, returns a point that is at
 * the end of the previous node if stickyPreference is
 * STICKY_LEFT. Returns undefined otherwise, so we can fall back to
 * default Slate resolution.
 *
 * @param {Point} point
 * @param {Node} node
 * @param {string} stickyPreference
 * @return {Point}
 */

function resolvePointAtStartOfNode(point, node, stickyPreference) {
  if (stickyPreference === _constants.STICKY_LEFT) {
    // We're at the left edge of a node, and want to be in the
    // previous node instead.
    return pointAtEndOfPreviousText(point, node);
  } else {
    return;
  }
}

/**
 * Assuming point is at the end of node, returns a point that is
 * unchanged if stickyPreference is STICKY_LEFT. Returns undefined
 * otherwise, so we can fall back to default Slate resolution.
 *
 * @param {Point} point
 * @param {Node} node
 * @param {string} stickyPreference
 * @return {Point}
 */

function resolvePointAtEndOfNode(point, node, stickyPreference) {
  if (stickyPreference === _constants.STICKY_LEFT) {
    // We're at the end of a sticky node already, no need to adjust
    // anything.
    return point;
  } else {
    return;
  }
}